var path = '/configuration/dataSetEditor/content/repeatingForm/repeatingForm.tpl.html';
var html = "<div class=\"repeatingForm\">\n\n    <span class=\"staticText\"\n          ui-translate>repeatingForm.message</span>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;